import React from "react";
import { Row, Col } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "./styles.scss";

interface WizardBreadcrumbProps {
  title: string;
  onBack?: () => void;
  backLabel?: string;
  showBreadcrumb?: boolean;
}

const WizardBreadcrumb: React.FC<WizardBreadcrumbProps> = ({
  title,
  onBack,
  backLabel = "Back to Dashboard",
  showBreadcrumb = true,
}) => {
  if (!onBack || !showBreadcrumb) {
    return null;
  }

  return (
    <Row className={styles.breadcrumbRow}>
      <Col xs="auto">
        <button
          type="button"
          onClick={onBack}
          className={styles.backButton}
          aria-label={backLabel || "Back to dashboard"}
        >
          <i className="fas fa-arrow-left" aria-hidden="true" />
        </button>
      </Col>
    </Row>
  );
};

export default withStyles(styles)(WizardBreadcrumb);
